import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQueryWithReauth } from '../refresh/customBaseQuery';
import { ORGANIZATION_MEMBER_TAG } from '../organization/api';
import { AuthProps } from '../auth/types';

export const USER_PATH = 'user';
export const USER_DETAILS_TAG = 'USER_DETAILS_TAG';

export const userApi = createApi({
    reducerPath: USER_PATH,
    // refetchOnMountOrArgChange: true,
    // refetchOnReconnect: true,
    // refetchOnFocus: true,
    // keepUnusedDataFor: 0,
    tagTypes: [USER_DETAILS_TAG, ORGANIZATION_MEMBER_TAG],
    baseQuery: customBaseQueryWithReauth,
    endpoints: (builder) => ({
        getAuthUrl: builder.query<any, any>({
            query: ({ locale, callbackUrl }) => ({
                url: '/oauth/authorization',
                method: 'GET',
                params: {
                    callbackUrl,
                    locale
                }
            })
        }),
        handleLogout: builder.mutation<string, void>({
            query: () => ({
                url: '/user/logout',
                method: 'POST'
            })
        }),
        getUserDetails: builder.query<AuthProps, void>({
            query: () => '/user/profile',
            providesTags: [USER_DETAILS_TAG]
        })
    })
});

export const { useLazyGetAuthUrlQuery, useGetUserDetailsQuery, useHandleLogoutMutation } = userApi;
